import { Expense } from "../../../entriesAPI";

export const formatAmount = (amount: string) => {
  // Normalize the input by replacing commas with dots
  const normalizedAmount = amount.replace(",", ".");

  // Parse the normalized amount
  const parsedAmount = parseFloat(normalizedAmount);

  // Format the number with 2 decimal places or as an integer
  let formattedAmount =
    parsedAmount % 1 === 0 ? parsedAmount.toFixed(0) : parsedAmount.toFixed(2);

  // Replace the decimal dot with a comma for the output
  formattedAmount = formattedAmount.replace(".", ",");

  return formattedAmount;
};

export const formatHours = (amount: string) => {
  const decimalHours = parseFloat(amount);
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours % 1) * 60);
  return `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;
};

export const calculateTotalExpenses = (expenses: Expense[]) => {
  let total = 0;
  expenses.forEach((expense) => {
    // Convert the expense total to a float and add it to the total
    total += parseFloat(expense.total.replace(",", "."));
  });
  // Format total to have 2 decimal places, then replace the dot with a comma
  return total.toFixed(2).replace(".", ",");
};
